
<template>
  <div>
    <div class="my-2">
      <span>Plano de ação:</span>
    </div>
    <action-plan-form @validChange='handleValidChange' ></action-plan-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ActionPlanFail',
  components: {
    ActionPlanForm: () => import("@/_action-plan/components/Form2.vue"),
  },
  inject: ['form'],
  prop: ['action_plan_valid', 'rules'],
  model: {
    prop: "action_plan_valid",
    event: "validChanged"
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    handleValidChange(e){
      // console.log('handleValidChange', {e});
      // console.log('reqq', this.required[0](e)); 
      if (this.required[0](e) != true){
        this.errorBag = {...this.errorBag, 0: this.required[0](e)}
      }
      // this.$emit('update:error', !e)
      // this.$emit('input', !e)
      this.$emit('validChanged', e)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      defaultActionPlan: state => state.Execution.default_action_plan,
      question: state => state.Execution.question,
      oneExecution: state => state.Execution.oneExecution,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>
